import { TbReceipt2, TbBuildingBank, TbBuildingStore } from "react-icons/tb";
import { FlowEntryCard } from "../shared/FlowEntryCard";
import { PAYMENT_TYPES } from "./config/lipaBidhaaConfig";
import useLipaBidhaaStore from "../../stores/lipaBidhaaStore";

const PAYMENT_OPTIONS = [
  {
    Icon: TbReceipt2,
    title: "Paybill",
    description: "Pay business numbers for utility bills and stock supplies.",
    path: "/lipa-bidhaa/paybill",
    paymentType: PAYMENT_TYPES.PAYBILL,
  },
  {
    Icon: TbBuildingStore,
    title: "Till Number",
    description: "Buy goods directly from retail shops using their till.",
    path: "/lipa-bidhaa/till-number",
    paymentType: PAYMENT_TYPES.TILL_NUMBER,
  },
  {
    Icon: TbBuildingBank,
    title: "Paykit to Paykit",
    description: "Instant wallet-to-wallet transfer to other Paykit merchants.",
    path: "/lipa-bidhaa/paykit",
    paymentType: PAYMENT_TYPES.B2B,
  },
];

export function LipaBidhaaContent({ isBlocked = false }) {
  return (
    <div className="grid grid-cols-1 xs:grid-cols-2 sm:grid-cols-3 gap-6 mt-2">
      {PAYMENT_OPTIONS.map(({ Icon, title, description, path, paymentType }) => (
        <FlowEntryCard
          key={path}
          Icon={Icon}
          title={title}
          description={description}
          path={path}
          isBlocked={isBlocked}
          onGetStarted={() => {
            const { reset, setPaymentType, activateFlow } =
              useLipaBidhaaStore.getState();
            reset();
            setPaymentType(paymentType);
            activateFlow();
          }}
        />
      ))}
    </div>
  );
}
